<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-data-table
      :headers="headers"
      :items="pageGroups"
      :loading="loading"
      :hide-default-footer="group.page_groups.length < 10"
      :items-per-page="10"
      class="elevation-2 my-2"
    >
      <template #top>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="8"
            class="primary--text font-weight-bold"
          >
            {{ $t('group.page_group_listing',
                  {name: `${$i18n.locale === 'jp' ? group.name_jp : group.name_en }`,id: group.id}) }}
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="text-end"
          >
            <v-tooltip
              v-if="!group.default"
              top
            >
              <template #activator="{on, attrs}">
                <v-btn
                  color="primary"
                  dark
                  small
                  :block="$vuetify.breakpoint.smAndDown"
                  v-bind="attrs"
                  @click="$emit('assignModule')"
                  v-on="on"
                >
                  {{ $t('group.assign') }}
                </v-btn>
              </template>
              <span>{{ $t('group.assign_module_to_user_group') }}</span>
            </v-tooltip>
            <v-chip
              v-else
              small
              color="error"
            >
              {{ $t('group.unchangeable') }}
            </v-chip>
          </v-col>
        </v-row>
      </template>
      <template #[`item.desc`]="{item}">
        <v-chip
          v-if="item.auto_allowed && !group.default"
          small
          color="error"
        >
          {{ $t('group.unchangeable') }}
        </v-chip>
        {{ item.desc }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    headers() {
      return [
        { text: this.$t('group.page_group_name'), value: 'name', class: 'complimentary white--text'},
        { text: this.$t('group.page_group_description'), value: 'desc', class: 'complimentary white--text'},
      ]
    },
    pageGroups () {
      return this.group
        .page_groups
        .filter(x => !x.hidden)
        .map(x => {
          x.name = this.$i18n.locale === 'en' ? x.name_en : x.name_jp
          x.desc = this.$i18n.locale === 'en' ? x.desc_en : x.desc_jp
          return x
        })
    }
  }
}
</script>

<style scoped>

</style>
